exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._3ifJFK7cyPtCwUYp45A9Tb{white-space:pre-wrap}._1-Vbe95v5CF1BrZAc8nav2:not(:first-child){margin-left:1.42857rem}._2-IaH79D5650Z66Erza85J,._1109EL2sIGXk1rikWRSQIy{height:100%}._38RF21Shz9-joUe8kxjTF0{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;padding-top:.57143rem}._6yQs0DAvWSVKe7RuClvx8{-webkit-box-flex:1;-webkit-flex:1 1 100%;-moz-box-flex:1;-ms-flex:1 1 100%;flex:1 1 100%;max-width:100%}@media only screen and (min-width:640px){._6yQs0DAvWSVKe7RuClvx8{-webkit-flex-basis:0;-ms-flex-preferred-size:0;flex-basis:0}}._6yQs0DAvWSVKe7RuClvx8:not(:last-child){margin-bottom:1.42857rem}@media only screen and (min-width:640px){._6yQs0DAvWSVKe7RuClvx8:not(:last-child){margin-bottom:0;margin-right:2.14286rem}}._3Rx98_EjkQ_yqfSP38-sg3{margin-left:1.07143rem;padding:0}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"StudentReportView_unitSummary_body": "_3ifJFK7cyPtCwUYp45A9Tb",
	"StudentReportView_card_icon": "_1-Vbe95v5CF1BrZAc8nav2",
	"StudentReportView_student_card": "_2-IaH79D5650Z66Erza85J",
	"StudentReportView_teachers_card": "_1109EL2sIGXk1rikWRSQIy",
	"StudentReportView_teachers_list": "_38RF21Shz9-joUe8kxjTF0",
	"StudentReportView_teachers_item": "_6yQs0DAvWSVKe7RuClvx8",
	"StudentReportView_teachers_profile": "_3Rx98_EjkQ_yqfSP38-sg3"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/UnitReportHFv4/StudentReportView/style.postcss
// module id = 1915
// module chunks = 0